import React from 'react'
import { __DEV__ } from '@mote/helpers/constants'
import { PortalManagerProvider } from './PortalManagerProvider'

export interface PortalManagerProps {
  children?: React.ReactNode
  zIndex?: number
}

export const PortalManager = (props: PortalManagerProps): JSX.Element => (
  <PortalManagerProvider value={{ zIndex: props.zIndex }}>
    {props.children}
  </PortalManagerProvider>
)

if (__DEV__) {
  PortalManager.displayName = 'PortalManager'
}
